import { useParams, Params } from 'react-router-dom';
import React, { ComponentType } from 'react';

interface WithRouterProps {
  params: Params;
}

export default function withRouter<T>(
  Component: ComponentType<T & WithRouterProps>,
) {
  return (props: T) => {
    const params = useParams<Params>();

    return <Component {...props} params={params} />;
  };
}
